<template>
  <div class="body_print">
    <h1 class="header-title_print">
      {{ objEmail.emailTitle }}
    </h1>
    <div class="mrB15" />
    <div class="comm_view_wrap">
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_PRTG_USR')"
          />
        </div>
        <div class="col-xs-11">
          {{ objEmail.printUserName }}
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_SEND_USR')"
          />
        </div>
        <div class="col-xs-11">
          {{ objEmail.sendUserName }}
        </div>
      </div>
      <!-- <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_RCPT_USR')"
          />
        </div>
        <div class="col-xs-11">
          <ul>
            <li
              v-for="item in objEmail.receiptUserList"
              :key="item.id"
            >
              {{ item.id }}
            </li>
          </ul>
        </div>
      </div> -->
      <!-- <div
        v-if="objEmail.referenceUserList.length > 0"
        class="row"
      >
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_REF_USR')"
          />
        </div>
        <div class="col-xs-11">
          <ul>
            <li
              v-for="item in objEmail.referenceUserList"
              :key="item.id"
            >
              {{ item.id }}
            </li>
          </ul>
        </div>
      </div> -->
      <div
        v-if="objEmail.attachDocumentId !== null"
        class="row"
      >
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TIT_ATTH_FILE_NM')"
          />
        </div>
        <div class="col-xs-11">
          {{ objEmail.attachFileName }}
        </div>
      </div>
    </div>
    <!-- <div class="underLine"></div>    -->
    <div class="mrB30" />
    <sui-web-editor
      ref="tuiEditor"
      :isViewer="isEditorViewerMode"
      class="width100"
      @loaded="loadEmailInfo"
    />
    <div class="comm_btn_wrap">
      <sui-button
        v-permission:print="contextPageId"
        type="button"
        class="comm_btn_solid"
        @click="onPrintClick"
      >
        {{ $t("MSG_BTN_PRTG") }}
      </sui-button>
    </div>
  </div>
</template>

<script>
import BasePage from '~cm/components/BasePage';

/* eslint max-len: ["error", { "code" : 500 }] */
export default {
  name: 'PGE_CMM_00007', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  data() {
    return {
      isShownPopupDetail: false,
      searchData: {},
      searchEmailType: '',
      attachGroupId: 'ATG_CMM_MAIL_COMMON',
      isEditorViewerMode: true,
      objEmail: {
        emailUid: '',
        connectionEmailId: '',
        emailTypeCode: '',
        emailTitle: '',
        sendTemplateId: '',
        emailContent: '',
        sendUserEmail: '',
        emailSendStateCode: '',
        attachDocumentId: '',
        attachFileName: '',
        batchJobStateCode: '',
        batchJobRETRYNumberOf: '',
        emailReservationYn: '',
        emailStartDTM: '',
        sendUserName: '',
        printUserName: '',
        emailReceiptUserId: '',
        emailReceiptUserName: '',
        emailReceiptUserCount: '',
        receiptUserList: [],
        referenceUserList: [],
      },
      receiptUserTypeCode: '',
      // objReceiptUserInfo: [],
      receiptUserTypeYn: '',
      initBody: '',
    };
  },
  computed: {
  },
  watch: {},
  created() {
  },
  mounted() {
    this.$nextTick(() => {
      this.onLoad();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onLoad() {
      this.searchData = utils.getParameter(this, 'searchData');
      this.searchEmailType = utils.getParameter(this, 'searchEmailType');
      this.loadEmailInfo();
      setTimeout(() => {
        this.onPrintClick();
      }, 500);
    },
    loadEmailInfo() {
      const emailUid = utils.getParameter(this, 'emailUid');
      const dataParams = {
        searchEmailType: this.searchEmailType,
      };

      if (!utils.isEmpty(emailUid)) {
        // http.requestTest('get', `/api/v1/common/email/${email-uid}`, {
        http.request(this.contextPageId, 'DTS_CMM_00004', {
          path: {
            'email-uid': emailUid,
          },
          query: dataParams,
        }).then(res => {
          this.objEmail.emailUid = res.data[0].emailUid;
          this.objEmail.emailTitle = res.data[0].emailTitle;
          this.objEmail.sendUserName = `${res.data[0].sendUserName}/${res.data[0].careerLevelName}/${res.data[0].departmentName}/${res.data[0].companyName}(${utils.dateformatToClient(res.data[0].emailStartDTM)})`;
          this.objEmail.attachDocumentId = res.data[0].attachDocumentId;
          this.objEmail.attachFileName = res.data[0].attachFileName;
          this.objEmail.emailContent = res.data[0].emailContent;
          this.$refs.tuiEditor.setHtml(res.data[0].emailContent);

          this.objEmail.printUserName = `${this.$store.getters.userInfo.userName}/${this.$store.getters.userInfo.departmentName}/${this.$store.getters.userInfo.companyName}(${utils.now('YYYY-MM-DD HH:mm:ss')})`;

          utils.forEach(res.data, data => {
            if (data.emailReceiptUserTypeCode !== 'BCC') {
              this.objEmail.emailReceiptUserName = data.emailReceiptUserName;
              this.objEmail.emailReceiptUserTypeCode = data.emailReceiptUserTypeCode;
              if (data.emailReceiptUserTypeCode === 'TO') {
                this.objEmail.receiptUserList.push({
                  id: `${data.emailReceiptUserName}/${data.careerLevelName}/${data.departmentName}/${data.companyName}`,
                });
              }
              if (data.emailReceiptUserTypeCode === 'CC') {
                this.objEmail.referenceUserList.push({
                  id: `${data.emailReceiptUserName}/${data.careerLevelName}/${data.departmentName}/${data.companyName}`,
                });
              }
              console.log('referenceUserList.length==>', this.objEmail.referenceUserList.length);
            }
          });
        });
      }
    },
    onPrintClick() {
      window.print();
    },
  },
};
</script>

<style scoped>
.body_print {
    height: 100%;
    overflow:auto;
    width: 100%;
    padding: 30px;
    white-space: nowrap;
}
.underLine {border-bottom:2px solid #000000}
.col-xs-1 {background-color:#ffffff !important}
.col-xs-11 {white-space:normal !important}
.header-title_print {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    font-size: 20px;   
    font-weight: bold;
    line-height: 1.5;
    color: #000000;
    white-space: normal;
}
</style>
